/**
 * How to get Topspin onto the home screen. Shown on the first-run gate *before* the group ID
 * field, because installing first and entering the ID second is the order that works: iOS
 * gives the installed app its own storage, so anything entered in Safari stays in Safari (§5).
 *
 * Both platforms get their own numbered list — the steps differ enough that folding Android
 * into a footnote left half the players guessing.
 */

/** Crude, but it only decides which group is read first; both are always on the page. */
function isAndroid(): boolean {
  return /android/i.test(navigator.userAgent);
}

function AppleSteps() {
  return (
    <div className="install-group">
      <h3>On Apple devices…</h3>
      <ol className="steps">
        <li>
          Tap the <strong>Share</strong> button in Safari (the square with an arrow).
        </li>
        <li>
          Scroll down and tap <strong>Add to Home Screen</strong>.
        </li>
        <li>
          Once added, Topspin App now opens like an app and works offline.
        </li>
        <li>
          Close Safari and open Topspin App from your home screen.
        </li>
      </ol>
    </div>
  );
}

function AndroidSteps() {
  return (
    <div className="install-group">
      <h3>On Android devices…</h3>
      <ol className="steps">
        <li>
          Tap the options menu in Chrome (the three vertical dots).
        </li>
        <li>
          Scroll down and tap <strong>Add to Home Screen</strong>.
        </li>
        <li>
          Once added, Topspin App now opens like an app and works offline.
        </li>
        <li>
          Close Chrome and open Topspin App from your home screen.
        </li>
      </ol>
    </div>
  );
}

export default function InstallSteps() {
  return isAndroid() ? (
    <>
      <AndroidSteps />
      <AppleSteps />
    </>
  ) : (
    <>
      <AppleSteps />
      <AndroidSteps />
    </>
  );
}
